import React, {useState, useEffect} from "react";
import Api from "../../services/Api";
import CalendarBig from "../../components/CalendarBig";
import {CalEventInterface} from "../../interfaces/common";
import {convertToWeekDate} from "../../helpers/dateFunctions";

export default function AvailabilitySummary() {

  const api = Api.getInstance();
  const [available, setAvailable] = useState<Array<CalEventInterface>>([]);
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    getData()
  }, [])

  const today = new Date()

  const getData = () => {
    api.get('coach/availability/get?summary=1').then((result) => {
      const availableEvents: Array<CalEventInterface> = []

      let id = 1
      for (const available of result.json.available) {
        let from = new Date(available.from)
        let to = new Date(available.to)
        if (available.title === 'R') {
          from = convertToWeekDate(today, from)
          to = convertToWeekDate(today, to)
        }
        if (available.title === 'S' && from.getDate() !== to.getDate()) {
          // We cannot render event from 0 to 0 next day. If we find that, change to start at 1 and end 23
          if (from.getHours() === 0) {
            from.setHours(1);
          }
          if (to.getHours() === 0) {
            to.setDate(to.getDate() -1);
            to.setHours(23);
          }
        }
        availableEvents.push({
          id: id,
          dbId: available.id,
          title: available.title,
          start: from,
          end: to,
        })
        id++
      }

      setAvailable(availableEvents)
      setLoaded(true)
    })
  }

  if (!loaded) {
    return (<div className="mt-4">Loading...</div>)
  }

  return (
    <>
      <div className="mt-4">
        <CalendarBig key="cal_r" startEvents={available} save={false} calType="summary"/>
      </div>
    </>
  )
};
